// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BvYMUSHQ3VZhSV {
  overflow: visible;
}
.BvYMUSHQ3VZhSV.n2JiYx2TrpRj9Z {
  width: 640px;
  margin: var(--ds-space-0, 0) auto;
  transition: width 0.3s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .BvYMUSHQ3VZhSV.n2JiYx2TrpRj9Z {
    transition: none;
  }
}
.BvYMUSHQ3VZhSV.n2JiYx2TrpRj9Z.udR7hhdNKnONkc {
  width: 1084px;
}
@media only screen and (min-width: 601px) and (max-width: 1099px) {
  .BvYMUSHQ3VZhSV.n2JiYx2TrpRj9Z.udR7hhdNKnONkc {
    width: calc(100vw - var(--ds-space-200, 16px));
  }
}
@media only screen and (max-width: 600px) {
  .BvYMUSHQ3VZhSV.n2JiYx2TrpRj9Z,
  .BvYMUSHQ3VZhSV.n2JiYx2TrpRj9Z.udR7hhdNKnONkc {
    width: calc(100vw - var(--ds-space-200, 16px));
    margin: var(--ds-space-400, 32px) var(--ds-space-100, 8px) var(--ds-space-0, 0);
  }
}
@media only screen and (max-width: 750px) {
  .BvYMUSHQ3VZhSV > div {
    /* stylelint-disable-next-line declaration-no-important */
    margin: var(--ds-space-0, 0) !important;
  }
}
`, ""]);
// Exports
export var cardBackDialog = `BvYMUSHQ3VZhSV`;
export var cardBackRedesign = `n2JiYx2TrpRj9Z`;
export var withPanel = `udR7hhdNKnONkc`;
export default ___CSS_LOADER_EXPORT___;
